import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LinksState } from './links.state';

export const selectLinksState = createFeatureSelector<LinksState>('adminLinks');

export const selectAllLinks = createSelector(
  selectLinksState,
  (state) => state.links,
);

export const selectLinksLoading = createSelector(
  selectLinksState,
  (state) => state.loading,
);

export const selectLinksError = createSelector(
  selectLinksState,
  (state) => state.error,
);

export const selectLinksPagination = createSelector(
  selectLinksState,
  (state) => state.pagination,
);

export const selectLinksParams = createSelector(
  selectLinksState,
  (state) => state.params,
);
